import { ComponentPropsWithoutRef } from 'react'

import { ButtonProps } from '@inno-ui/button'

type AuthInputActionButton = {
  show: boolean
} & Omit<ButtonProps, 'size' | 'color' | 'variant'>

export interface AuthInputProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'type' | 'className'> {
  type?: 'text' | 'password' | 'email'
  className?: string
  inputClassName?: string
  actionButton?: AuthInputActionButton
  error?: string
  showTogglePassword?: boolean
}
